<app-entity-mat-dialog-title title="Manage Events" [closeData]="closeData"></app-entity-mat-dialog-title>

<div [ngClass]="{ 'loading-shade': showProgressSpinner }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

        <app-error-message [message]=this.errorMessage></app-error-message>

        <div class="container">
            <div class="row mb-2">
                <div class="col-12 d-flex justify-content-end">
                    <button type="button" mat-stroked-button color="primary" (click)="openCreateEventDialog()">
                        <mat-icon>add</mat-icon>
                        New Event
                    </button>
                </div>
            </div>

            <div class="row" *ngIf="!showProgressSpinner && !events.length">
                <div class="col-12">
                    <p class="text-muted mb-0">No events yet. Use "New Event" to create one.</p>
                </div>
            </div>

            <!-- Franchise Events -->
            <div class="row" *ngIf="franchiseEvents.length">
                <div class="col-12">
                    <h3 class="mt-3">Franchise Events</h3>
                    <mat-divider class="mb-3"></mat-divider>
                    <ng-container *ngTemplateOutlet="eventTable; context: { $implicit: franchiseDataSource }"></ng-container>
                </div>
            </div>

            <!-- This Studio's Events -->
            <div class="row" *ngIf="studioEvents.length">
                <div class="col-12">
                    <h3 class="mt-3">This Studio's Events</h3>
                    <mat-divider class="mb-3"></mat-divider>
                    <ng-container *ngTemplateOutlet="eventTable; context: { $implicit: studioDataSource }"></ng-container>
                </div>
            </div>
        </div>

    </div>

</div>

<!-- Shared table for both groups, so the two can't drift apart. -->
<ng-template #eventTable let-tableDataSource>
    <table mat-table multiTemplateDataRows [dataSource]="tableDataSource" class="w-100 mat-elevation-z2">

        <!-- Title Column -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let event"> {{ event.title }} </td>
        </ng-container>

        <!-- Package Code Column -->
        <ng-container matColumnDef="packageCode">
            <th mat-header-cell *matHeaderCellDef> Package Code </th>
            <td mat-cell *matCellDef="let event"> {{ packageCodeName(event.packageCode) }} </td>
        </ng-container>

        <!-- Dates Column -->
        <ng-container matColumnDef="dates">
            <th mat-header-cell *matHeaderCellDef> Dates </th>
            <td mat-cell *matCellDef="let event"> {{ event.dateStart }} &ndash; {{ event.dateEnd }} </td>
        </ng-container>

        <!-- Linked packages Column: a count that decides whether delete is
             offered, so it reads as a status rather than a bare integer. -->
        <ng-container matColumnDef="linkedPackages">
            <th mat-header-cell *matHeaderCellDef> Linked packages </th>
            <td mat-cell *matCellDef="let event">
                <mat-chip-list>
                    <mat-chip *ngIf="event.linkedPackages" color="primary" selected>
                        {{ event.linkedPackages }}
                    </mat-chip>
                    <mat-chip *ngIf="!event.linkedPackages" disabled>
                        None
                    </mat-chip>
                </mat-chip-list>
            </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let event" class="text-end">
                <ng-container *ngIf="canManage(event)">
                    <button type="button" mat-icon-button color="primary"
                        matTooltip="Edit event"
                        aria-label="Edit event"
                        (click)="openEditEventDialog(event)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <!-- Material suppresses tooltips on disabled buttons, so the
                         reason lives on a wrapper that stays enabled. -->
                    <span [matTooltip]="deleteBlockedTooltip(event)"
                        [matTooltipDisabled]="!isDeleteBlocked(event)">
                        <button type="button" mat-icon-button color="warn"
                            [disabled]="isDeleteBlocked(event) || !!deletingId"
                            aria-label="Delete event"
                            (click)="startDelete(event)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </span>
                </ng-container>
            </td>
        </ng-container>

        <!-- Inline delete confirmation, rendered as a mat-table expansion row
             so the table keeps ownership of its own row structure. -->
        <ng-container matColumnDef="confirmDelete">
            <td mat-cell *matCellDef="let event" [attr.colspan]="displayedColumns.length">
                <div class="d-flex flex-wrap align-items-center justify-content-end gap-2 py-2">
                    <span class="me-auto">Delete "{{ event.title }}"? This action can't be undone.</span>
                    <button type="button" mat-button (click)="cancelDelete()">Cancel</button>
                    <button type="button" mat-raised-button color="warn"
                        [disabled]="!!deletingId"
                        (click)="confirmDelete(event)">Delete Event</button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let event; columns: displayedColumns;"></tr>
        <tr mat-row *matRowDef="let event; columns: confirmColumns; when: isConfirmDeleteRow"></tr>
    </table>
</ng-template>

<mat-dialog-actions align="end">
    <button type="button" (click)="closeDialog()" mat-raised-button color="accent">Close</button>
</mat-dialog-actions>
